import HomeView from '../pages/home/home-view';
import NearbyView from '../pages/nearby/nearby-view';
import NotificationsView from '../pages/notifications/notifications-view';
import BookmarksView from '../pages/bookmarks/bookmarks-view';
import ProfileView from '../pages/profile/profile-view';
import AuthView from '../pages/auth/auth-view';
import PrivacyView from '../pages/privacy/privacy-view';
import CookiesView from '../pages/cookies/cookies-view';

const routes = {
  '/': new HomeView(),
  '/nearby': new NearbyView(),
  '/notifications': new NotificationsView(),
  '/bookmarks': new BookmarksView(),
  '/profile': new ProfileView(),
  '/auth': new AuthView(),
  '/privacy': new PrivacyView(),
  '/cookies': new CookiesView(),
};

export default routes;